/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import {loadModules} from 'esri-loader';
import {error} from '@ion/core/src/logger/logger';

/**
 * Provides an async utility initializing a list of esri modules
 *
 * ```typescript
 *
 *   import {initializeEsriModules} from '@ion/dls/src/maps/helpers';
 *
 *   const [
 *     Graphic,
 *     GraphicsLayer,
 *   ] = await initializeEsriModules('esri/Graphic', 'esri/layers/GraphicsLayer');
 *
 * ```
 *
 */
export function initializeEsriModules(...args): Promise<any> {
  return new Promise((resolve, reject) => {
    loadModules(args)
      .then(moduleNames => {
        resolve(moduleNames);
      })
      .catch(err => {
        reject(error(err));
      });
  });
};

export default initializeEsriModules;
